import $ from "jquery";

const copyUrl = (options) => {
    const settings = {
        buttonSelector: options.buttonSelector || '',
        textToCopy: options.textToCopy || '',
        toastMessage: options.toastMessage || 'Text copied successfully'
    };

    const init = () => {
        execute();
    };

    const execute = () => {
        if (!settings.buttonSelector || $(settings.buttonSelector).length === 0) return;

        $(function ($) {
            $(settings.buttonSelector).on('click', function () {
                const $tempInput = $('<input>');
                $('body').append($tempInput);
                $tempInput.val(settings.textToCopy).select();
                document.execCommand('copy');
                $tempInput.remove();

                // Call the toast function
                window.showToast(settings.toastMessage);
                // if (typeof window.showToast === 'function') {
                // } else {
                //     console.log(settings.toastMessage);
                // }
            });
        });
    };

    init();
};

try {
    copyUrl({
        buttonSelector: '#copy-url-btn',
        textToCopy: window.location.href,
        toastMessage: 'Erfolgreich versendet'
    });
    copyUrl({
        buttonSelector: '#copy-email-btn',
        textToCopy: 'hallo@connectly.de',
        toastMessage: 'E-Mail erfolgreich kopiert!'
    });
} catch (error) {
    console.error('copyUrl', error);
}
